import { IController, ITimeoutService } from 'angular';
import { inject, injectable } from '../../../../shared/utils/inject/inject';
import { IHeightCalc } from '../../services/heightCalc/heightCalc.factory';
import { ISettings, IWixBinding } from '../../services/wix/wixBinding';

@injectable
export class TitleBarController implements IController {
  settings: ISettings;
  @inject wixBinding: IWixBinding;
  @inject $timeout: ITimeoutService;
  @inject heightCalc: IHeightCalc;

  $onInit(): void {
    this.settings = this.wixBinding.getSettings();
    this.$timeout(() => {
      this.heightCalc.scrollInit();
    }, 100);
  }
}
